import { screenXsMax, spacer4 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { cssColorValue, semanticColors } from "../../styles";
export var Required = styled.span.withConfig({
  displayName: "Required",
  componentId: "sc-7zzom7-0"
})(["color:", ";border-block-end:0;text-decoration:none;padding-inline-start:", ";@media (max-width:", "){flex:1;}"], cssColorValue(semanticColors.textNegative), spacer4, screenXsMax);